const symbols = {
  DATA: Symbol('data'),
};

export default symbols;
